<template>
  <div
    class="col-12 d-flex align-items-end justify-content-between sticky-bottom theme-footer"
  ></div>
</template>

<script>
import global from "../global";

export default {
  name: "TypeBotNav",
  setup() {
    const { theme } = global;

    return {
      theme,
    };
  },
};
</script>
